/**
 * Data source factory.
 * Returns a singleton Supabase provider (via the proxy's /inbox/* endpoints).
 */
import { DataSource } from './types';
import { SupabaseProvider } from './supabaseProvider';

let instance: DataSource | null = null;

export function getDataSource(): DataSource {
  if (!instance) {
    instance = new SupabaseProvider();
  }
  return instance;
}

export type { DataSource };
